<div #dataLoading="appIsLoading" [appIsLoading]="loadingService.isLoading(this)">
  <div class="claim-filter-section bg-color2">
    <h2 class="pb-3">TDS Reports Filter</h2>

    <form [formGroup]="tdsReportsFilterForm" *ngIf="tdsReportsFilterForm" (ngSubmit)="onSubmit()">
      <div class="grid grid-gap-10 grid-col-md-50 grid-col-hd-50 grid-col-xs-100 grid-col-sm-100 grid-col-lt-100">
        <div class="addContactControls remove-right-margin col-100">
          <label>Order Status Id</label><br>
          <select formControlName="orderStatusId" class="form-control">
            <option value="">Select Order Status</option>
            <option *ngFor="let item of orderStatusesList" [value]="item.orderTypeId">
              {{ item.orderTypes }}
            </option>
          </select>
        </div>

        <div class="addContactControls remove-right-margin col-100">
          <label>Reward Type</label><br>
          <select formControlName="rewardType" class="form-control">
            <option value="">Select Order Status</option>
            <option *ngFor="let item of rewardTypesList" [value]="item.pointTypeId">
              {{ item.pointTypes }}
            </option>
          </select>
        </div>

        <div class="addContactControls remove-right-margin col-100">
          <label>From Date</label><br>
          <div class="input-group">
            <input formControlName="fromDate" placeholder="Select Date" class="form-control" ngbDatepicker
              #fromDatePicker="ngbDatepicker" [minDate]="minDate" [maxDate]="maxDate" readonly />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" (click)="fromDatePicker.toggle()"
                type="button"></button>
            </div>
          </div>

        </div>

        <div class="addContactControls remove-right-margin col-100">
          <label>To Date</label><br>
          <div class="input-group">
            <input formControlName="toDate" placeholder="Select Date" class="form-control" ngbDatepicker
              #toDatePicker="ngbDatepicker" [maxDate]="maxDate" [minDate]="minDate" readonly />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" (click)="toDatePicker.toggle()" type="button"></button>
            </div>
          </div>
        </div>

        <div class="addContactControls remove-right-margin col-100">
          <label>Order Number</label><br>
          <input formControlName="orderNumber" placeholder="Order Number" class="form-control" />
        </div>


        <div class="addContactControls remove-right-margin col-100">
          <label>Program Number</label><br>
          <input formControlName="programNumber" placeholder="Program Number" class="form-control" />
        </div>

        <div class="addContactControls remove-right-margin col-100">
          <label>Bank Account Number</label><br>
          <input formControlName="bankAccountNumber" placeholder="Bank Account Number" class="form-control" />
        </div>

      </div>
      <div class="d-flex justify-content-center pt-5">
        <button type="submit" class="btn btn-primary customBtnSearch">Submit</button>
        <button type="button" class="btn btn-primary customBtnReset" (click)="resetFormValues()">Clear</button>
      </div>
    </form>
  </div>

  <!-- table -->
  <div class="bg-color2 mt-5 p-4">
    <div class="d-flex py-4 justify-content-end"
      *ngIf="!dataLoading.appIsLoading && paginationDetails.totalNumberOfItems > 0">
      <button type="button" class="btn btn-primary customBtnSearch" (click)="downloadCSV()">Download Report</button>
    </div>
    <div class="table-width" *ngIf="paginationDetails.totalNumberOfItems > 0">
      <table class="table table-striped" aria-describedby="myTable">
        <thead>
          <tr>
            <!-- <th class="cm_12 cm_bold" role="button" scope="col" (click)="onSort('orderDetailId')"> -->
            <th class="cm_12 cm_bold" role="button" scope="col">
              Order Detail Id
              <!-- <cs-sort-icons *ngIf="sorter.showSortIcons('orderDetailId')"
                [sortAscending]="sorter.sortDirection"></cs-sort-icons> -->
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Program Number
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Reward Type
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Bank Account Number
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Order Number
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Order Line Number
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Model
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Vendor Item Id
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Quantity
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Total Points
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Total Amount
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Tax Percentage
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Base Point
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Base Amount
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              GST Amount
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Tax Points
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Tax Amount
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Order Status
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Tax Deducted Amount
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Financial Year
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Month
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Year
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Created At
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Created By
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Reference Id
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Tax Deducted Points
            </th>
            <th class="cm_12 cm_bold" role="button" scope="col">
              Tax Deducted Date
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of tdsReportsTableData">
            <td>{{item.orderDetailId}}</td>
            <td>{{item.programNumber}}</td>
            <td>{{item.rewardType}}</td>
            <td>{{item.bankAccountNumber }}</td>
            <td>{{item.orderNumber}}</td>
            <td>{{item.orderLineNumber}}</td>
            <td>{{item.model}}</td>
            <td>{{item.vendorItemId}}</td>
            <td>{{item.quantity}}</td>
            <td>{{item.totalPoints }}</td>
            <td>{{item.totalAmount}}</td>
            <td>{{item.taxPercentage}}</td>
            <td>{{item.basePoint}}</td>
            <td>{{item.baseAmount}}</td>
            <td>{{item.gstAmount}}</td>
            <td>{{item.taxPoints }}</td>
            <td>{{item.taxAmount}}</td>
            <td>{{item.orderStatus}}</td>
            <td>{{item.taxDeductedAmount}}</td>
            <td>{{item.financialYear}}</td>
            <td>{{item.month}}</td>
            <td>{{item.year }}</td>
            <td>{{item.createdAt}}</td>
            <td>{{item.createdBy}}</td>
            <td>{{item.referenceId }}</td>
            <td>{{item.taxDeductedPoints}}</td>
            <td>{{item.taxDeductedDate}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="couponSummaryNoData alert alert-danger"
      *ngIf="!dataLoading.appIsLoading && paginationDetails.totalNumberOfItems===0">
      No records found!
    </div>
  </div>

  <!-- pagination -->
  <div class="row" *ngIf="paginationDetails.totalNumberOfItems > 0">
    <div class="col-lg-12 pagination-center-Bottom">
      <cs-custom-pagination [paginationDetails]="paginationDetails" (onChangeEvent)="onChange($event)">
      </cs-custom-pagination>
    </div>
  </div>
</div>